export default "assets/images/f115726e6249018905cca51653e1262c.png";